import { notificationAdd } from "../../../actions/notification";
import { AppDispatch } from "../../../store";
import addNotificationContent from "./notification";

export type NotificationType = "error" | "success" | "info";

const dispatchNotification = {
  success: (dispatch: AppDispatch, message: string): void => {
    dispatch(notificationAdd(addNotificationContent(message, "success")));
  },
  error: (dispatch: AppDispatch, message: string): void => {
    dispatch(notificationAdd(addNotificationContent(message, "error")));
  }
};
export default dispatchNotification;
